import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface MessageToastPayload {
  key: string;
  params?: Record<string, unknown>;
}

@Injectable({ providedIn: 'root' })
export class MessageToastService {
  private readonly toastSubject = new Subject<MessageToastPayload>();

  get toast$(): Observable<MessageToastPayload> {
    return this.toastSubject.asObservable();
  }

  show(key: string, params?: Record<string, unknown>): void {
    if (!key?.trim()) {
      return;
    }

    this.toastSubject.next({ key, params });
  }
}
